const WIN_USER_AGENT_REGEX = /(PollEvPresenter|LiveSlides)\/(\d+\.\d+\.\d+).*Windows/
const MAC_USER_AGENT_REGEX = /Mac OS X (\d+_\d+_\d+).*(PollEvPresenter|LiveSlides)\/(\d+\.\d+\.\d+)/

/**
 * Gets the slideware platform that we're running in
 *
 * @return {string|null}
 *  "windows" if running on Windows
 *  "mac" if running on macOS
 *  "google" if running in Google Slides
 *  null otherwise
 */
export function platform () {
  const winMatches = WIN_USER_AGENT_REGEX.exec(navigator.userAgent)
  if (winMatches) {
    return 'windows'
  }

  const macMatches = MAC_USER_AGENT_REGEX.exec(navigator.userAgent)
  if (macMatches) {
    return 'mac'
  }

  // We don't have control over the userAgent in goog_presenter
  // but we can check if we're running in an <iframe>
  if (window.parent !== window) {
    return 'google'
  }

  return null
}
